/** Mirrors Core.DTO.GradeReportColumnScope (persisted as TINYINT). */
export enum GradeReportColumnScope {
	LessonCategory = 0,
	/** Dormant: per-criterion grade columns no longer render in any report. */
	ProjectCriteria = 1,
	ProjectMilestone = 2
}

/**
 * A stable, admin-defined report column. Grading template categories/criteria reference it by FK;
 * every row pointing at the same column pivots into one report column. Mirrors Core.DTO.GradeReportColumn.
 */
export interface IGradeReportColumn {
	gradeReportColumnID: number;
	scope: GradeReportColumnScope;
	/** Bare slug (no "grade_" prefix); the report's dynamic column identity. Unique per scope. */
	columnKey: string;
	/** Display label shown as the report column header. */
	columnLabel: string;
}

/**
 * One in-use grading name annotated with the column it currently resolves to.
 * Mirrors Core.DTO.GradeReportColumnUsage.
 */
export interface IGradeReportColumnUsage {
	name: string;
	gradeReportColumnID?: number | null;
	columnKey?: string | null;
	columnLabel?: string | null;
	usageCount: number;
	effectiveKey: string;
	effectiveLabel: string;
}
